/* eslint-disable eqeqeq */
import React, { Fragment } from 'react';
import moment from 'moment';
import { Table } from 'react-bootstrap';
import logo from '../../../../assets/unhcr-logo-blue.png';

function ComponentToPrint({ data, partner }, ref) {
    const getMonthName = (month) => {
        const months = [
            '', 'January', 'February', 'March', 'April', 'May', 'June',
            'July', 'August', 'September', 'October', 'November', 'December',
        ];
        return months[month] || '';
    };

    const dateRange = data?.month && data?.year
        ? `${getMonthName(data.month)} - ${data.year}`
        : data?.start_date && data?.end_date
        ? `${moment(data.start_date).format('DD MMM YYYY')} - ${moment(data.end_date).format('DD MMM YYYY')}`
        : '';

    return (
        <fieldset ref={ref} className="customFieldset donation p-5">
            <div className="text-center mb-4">
                <img className="mb-3" width="200px" src={logo} alt="" />
                <br />
                <h5 className="d-block text-decoration-underline mb-2">
                    D4 Reports: Global Dispatch Reports
                </h5>
                <h6 className="text-muted">{dateRange}</h6>
            </div>

            {data?.d4_records?.map((category) => (
                <Fragment key={category.id}>
                    <h6 className="ps-0 mt-4">{category.name}</h6>
                    <Table striped bordered hover className="mb-5" style={{ fontSize: '12px' }}>
                        <thead>
                            <tr>
                                <th
                                    rowSpan={2}
                                    style={{ verticalAlign: 'middle', lineHeight: '33px', minWidth: '200px' }}
                                >
                                    Item Name
                                </th>
                                <th
                                    rowSpan={2}
                                    className="text-center"
                                    style={{ verticalAlign: 'middle', lineHeight: '33px' }}
                                >
                                    Opening Balance
                                </th>
                                {partner?.map((p) => (
                                    <th
                                        key={p.id}
                                        className="text-center"
                                        style={{ lineHeight: '33px' }}
                                    >
                                        {p.name}
                                    </th>
                                ))}
                                <th
                                    className="text-center"
                                    style={{ lineHeight: '33px' }}
                                >
                                    Total
                                </th>
                            </tr>
                            <tr>
                                {partner?.map((p) => (
                                    <th key={p.id} className="text-center" style={{ lineHeight: '30px', fontSize: '11px' }}>
                                        Total Dispatch
                                    </th>
                                ))}
                                <th className="text-center" style={{ lineHeight: '30px', fontSize: '11px' }}>
                                    Total Dispatch
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {category.drug_list?.map((drug) => (
                                <tr key={drug.drug_id}>
                                    <td style={{ lineHeight: '33px' }}>{drug.drug_name}</td>
                                    <td className="text-center" style={{ lineHeight: '33px' }}>
                                        {drug.opening_balance || 0}
                                    </td>
                                    {partner?.map((p) => {
                                        const summary = drug.partner_summary_data?.find(
                                            (s) => s && parseInt(s.partner_id, 10) === parseInt(p.id, 10)
                                        );
                                        return (
                                            <td key={p.id} className="text-center" style={{ lineHeight: '33px' }}>
                                                {summary?.total_dispatch || 0}
                                            </td>
                                        );
                                    })}
                                    <td className="text-center" style={{ lineHeight: '33px' }}>
                                        {drug.overall_dispatch || 0}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                </Fragment>
            ))}
        </fieldset>
    );
}

const forwardedInput = React.forwardRef(ComponentToPrint);
export default forwardedInput;